import script from "./SEditor.vue?vue&type=script&setup=true&lang=ts"
export * from "./SEditor.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__
import QEditor from 'quasar/src/components/editor/QEditor.js';
import qInstall from "../../../../../portal/node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QEditor});
